export { tableVariables as tableRowVariables } from './tableVariables';
